<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment>
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchQna_wrap extend">
                <article class="srch_basic">
                    <dl class="dl_search">
                        <dd data-input-type="select">
                            <select class="slt_white w100p" v-model="myQnA">
                                <option value="Y">{{ $t('FIELD.QNA.MYQNASEL') }}</option>
                                <option value="N" v-if="'C310' !== corpCd">
                                    {{ $t('FIELD.FAST.DURATION.ALL') }} {{ $t('TITLE.FAVORITE.QNA') }}
                                </option>
                            </select>
                        </dd>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('FIELD.GLOBAL.ETC.088')"
                                v-model="searchTitle"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="search(1)">
                                {{ $t('BUTTON.GLOBAL.SEARCH') }}
                            </a>
                        </dd>
                    </dl>
                </article>
                <article class="srch_detail">
                    <!-- mobile -->
                    <dl class="dl_select tabmobile_only">
                        <dt>{{ $t('FIELD.GLOBAL.INQUIRY') }}</dt>
                        <dd data-input-type="select">
                            <fieldset class="ui_fieldset set_2">
                                <label class="select-wrap">
                                    <select class="slt_white w100p" v-model="inquiry1Code" @change="inquiryList(2)">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in inquiry1CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                        >
                                            {{ item.CD_NAME }}
                                        </option>
                                    </select>
                                </label>
                                <label class="select-wrap">
                                    <select class="slt_white w100p" v-model="inquiry2Code">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in inquiry2CodeList"
                                            :key="pageName + item.CD"
                                            :value="item.CD"
                                        >
                                            {{ item.CD_NAME }}
                                        </option>
                                    </select>
                                </label>
                            </fieldset>
                        </dd>
                    </dl>
                    <dl class="dl_select tabmobile_only">
                        <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                        <dd data-input-type="select">
                            <fieldset class="ui_fieldset set_2">
                                <label class="select-wrap">
                                    <select class="slt_white w100p" v-model="category1Code" @change="categoryList(2)">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in category1CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                            >{{ item.codeName }}</option
                                        >
                                    </select>
                                </label>
                                <label class="select-wrap">
                                    <select class="slt_white w100p" v-model="category2Code" @change="categoryList(3)">
                                        <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                        <option
                                            v-for="item in category2CodeList"
                                            :key="pageName + item.code"
                                            :value="item.code"
                                            >{{ item.codeName }}</option
                                        >
                                    </select>
                                </label>
                            </fieldset>
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{ $t('FIELD.GLOBAL.DATE') }}</dt>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input
                                            id="frDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="MM.DD.YYYY"
                                            readonly
                                            maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFrDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                        </a>
                                    </label>
                                    <div class="fr_datepicker" id="fr-picker-container" />
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="MM.DD.YYYY"
                                            readonly
                                            maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                        </a>
                                    </label>
                                    <div class="to_datepicker" id="to-picker-container" />
                                </span>
                            </fieldset>
                        </dd>
                        <dt>{{ $t('FIELD.FAST.ADVANCED.MODEL') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="searchModel"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{ $t('FIELD.MYKNOWLEDGE.IMEI') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="searchImei"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dt>{{ $t('FIELD.MYKNOWLEDGE.PARTS.NAME') }}/{{ $t('FIELD.MYKNOWLEDGE.PARTS.NUMBER') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="searchPart"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{ $t('FIELD.QNA.SERIAL.NUMBER') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="serialNumber"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dt>{{ $t('FIELD.QNA.SVC.ORDER') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                v-model="svcOrder"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                    </dl>
                    <dl class="dl_input">
                        <dt>{{ $t('FIELD.GLOBAL.STATUS') }}</dt>
                        <dd class="clearable" data-input-type="input">
                            <select class="slt_white w100p" v-model="searchStatus">
                                <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                <option v-for="item in qnaStatuses" :key="item.code" :value="item.code">{{
                                    item.codeName
                                }}</option>
                            </select>
                        </dd>
                        <dt></dt>
                        <dd class="clearable" data-input-type="input"></dd>
                    </dl>
                </article>
                <a href="javascript:" class="btn_ico_srchBtm" title="Fold" @click="srchBtmClick($event)">
                    <span class="sr_only"></span>
                </a>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">
                    {{ $t('TITLE.TOTAL.COUNT') }} : <em>{{ totalCount | numberFormat }}</em>
                </div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="excelDownload()">
                        {{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}
                    </a>
                </div>
                <toast-grid
                    :gridId="gridId"
                    :columns="columns"
                    :data="gridData"
                    :options="options"
                    :ref="gridId"
                    :key="gridKey"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="nRecordsPerPage"
                    @change="search"
                />
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css';
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import { EventBus } from '@/utils/EventBus';
import { SDLUtil, DateUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

import DatePicker from '~c/DatePicker';
import searchModelPopup from '~vb/faq/popup/searchModelPopup';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import ToastGrid from '~c/ToastGrid';
import CrossEditor from '~c/CrossEditor';
import InnorixUpload from '~c/InnorixUpload';
import SDLPagination from '~~c/control/pagination/Pagination';
import ExcelDownloadPopup from '~vb/common/ExcelDownloadPopup';

require('moment-jdateformatparser');

export default {
    name: 'questionList',
    props: {
        isSurvey: { default: false },
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'sdl-pagination': SDLPagination,
    },
    computed: {
        ...mapGetters({
            loginSystem: 'getLoginSystem',
            supportSnb: 'getSupportSnb',
            supportSnbParams: 'getSupportSnbParams',
            deptLevelCd: 'getDeptLevelCd',
            corpCd: 'getCorpCd',
            menus: 'getMenus',
        }),
    },
    data() {
        return {
            pageName: this.$route.name,
            pageTitle: '',
            myQnA: 'Y',
            searchTitle: '',
            searchImei: '',
            searchPart: '',
            serialNumber: '',
            svcOrder: '',
            searchFrAddDt: '',
            searchToAddDt: '',
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1CodeList: [],
            category2CodeList: [],
            inquiry1: '',
            inquiry2: '',
            inquiry3: '',
            inquiryETC: '',
            category1: '',
            category2: '',
            searchModel: '',
            searchStatus: '',
            qnaStatuses: [],
            totalCount: 0,
            currentPage: 1,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            isMobile: SDLUtil.isMobile,
            gridKey: 0,
            gridId: this.$route.name + 'Grid',
            columns: [],
            gridData: [],
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 450,
            },
            survey: this.isSurvey,
        };
    },
    mounted() {
        let toDate = new Date();
        let frDate = new Date();
        frDate.setDate(frDate.getDate() - 7);

        this.rangePicker = DatePicker.createRangeWithOpener(
            'fr-picker-container',
            'frDate',
            'icoFrDate',
            'to-picker-container',
            'toDate',
            'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            frDate,
            toDate,
        );

        if ('questionList' === this.supportSnbParams.pageTitle) {
            this.initParamSetting();
        }

        EventBus.$on('question-answer-list', param => {
            this.inquiry1 = param.qnaInquiry.inquiry1;
            this.inquiry2 = param.qnaInquiry.inquiry2;
            this.inquiry3 = param.qnaInquiry.inquiry3;
            this.inquiryETC = param.qnaInquiry.inquiryETC;
            this.category1 = param.qnaCategory.category1;
            this.category2 = param.qnaCategory.category2;
            this.search(1);
        });

        api.getCommonCodeList('QNA_STATUS', 'A').then(resp => {
            this.qnaStatuses = resp;
        });

        this.getMobileColumn();
        this.inquiryList(1);
        this.categoryList(1);
        // this.search(1);
    },
    methods: {
        ...mapActions(['setSupportSnbParams']),
        initParamSetting() {
            let mFormat = localStorage.getItem('mDateFormat');
            this.myQnA = this.supportSnbParams.myQnA;
            this.searchTitle = this.supportSnbParams.searchTitle;
            this.searchModel = this.supportSnbParams.searchModel;
            this.searchImei = this.supportSnbParams.searchImei;
            this.searchPart = this.supportSnbParams.searchPart;
            this.serialNumber = this.supportSnbParams.serialNumber;
            this.svcOrder = this.supportSnbParams.svcOrder;
            this.rangePicker.setStartDate(moment(this.supportSnbParams.searchFromAddDt, mFormat).toDate());
            this.rangePicker.setEndDate(moment(this.supportSnbParams.searchToAddDt, mFormat).toDate());
        },
        search(page) {
            this.currentPage = page;
            this.searchList();
        },
        getSearchParams() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';

            let searchParams = {
                pageTitle: 'questionList',
                multi: 'N',
                searchInfo: 'set',
                page: this.currentPage,
                systemId: this.loginSystem,
                myQnA: this.myQnA,
                searchTitle: this.searchTitle,
                searchModel: this.searchModel,
                serialNumber: this.serialNumber,
                svcOrder: this.svcOrder,
                searchImei: this.searchImei,
                searchPart: this.searchPart,
                searchFromAddDt: searchFromDt,
                searchToAddDt: searchToDt,
                searchStatus: this.searchStatus,
                inquiry1: this.inquiry1,
                inquiry2: this.inquiry2,
                inquiry3: this.inquiry3,
                inquiryETC: this.inquiryETC,
                category1: this.category1,
                category2: this.category2,
                searchInquiryType1: this.inquiry1Code,
                searchInquiryType2: this.inquiry2Code,
                searchCategoryA: this.category1Code,
                searchCategoryB: this.category2Code,
                isSurvey: this.survey,
            };
            return searchParams;
        },
        async searchList() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';
            if (parseInt((endDate - startDate) / (24 * 60 * 60 * 1000)) > 90) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.DATE.VALIDATION.DAY90'));
                return false;
            }

            let searchParams = this.getSearchParams();
            this.setSupportSnbParams(searchParams);

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionSearch.skp`,
                    qs.stringify(searchParams),
                )
                .then(resp => {
                    let URGENT =
                        '<em class="textcolor_urgent">[' + SDLUtil.getMsgProp('FIELD.GLOBAL.URGENT') + ']</em>';

                    for (const result of resp.data.result.rowData) {
                        if ('Y' === result.URGENT_YN) {
                            result.TITLE = URGENT + result.TITLE;
                        }

                        if ('DRA' === result.QNA_STATUS || 'ANS' === result.FLOW_STATUS) {
                            result.COLOR_STATUS_NM = '<span class="txt_draft">' + result.STATUS_NM + '</span>';
                        } else if ('PRO' === result.QNA_STATUS) {
                            result.COLOR_STATUS_NM = '<span class="txt_commented">' + result.STATUS_NM + '</span>';
                        } else if ('END' === result.QNA_STATUS) {
                            result.COLOR_STATUS_NM = '<span class="txt_answered">' + result.STATUS_NM + '</span>';
                        } else {
                            result.COLOR_STATUS_NM = '<span class="">' + result.STATUS_NM + '</span>';
                        }
                    }
                    this.gridData = [];
                    this.gridData = resp.data.result.rowData;
                    this.totalCount = resp.data.search.totalRecords;
                    this.gridKey++;
                    this.survey = false;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        tabClick(v) {
            //category list
            $('.tab_wrap li').on('click', function() {
                var li_index = $('.tab_menus li').index(this);
                if ($(this).hasClass('on') == true) {
                    $(this).removeClass('on');
                    $('.tab_wrap .tab_cont').hide();
                } else {
                    $('.tab_wrap li').removeClass('on');
                    $('.tab_wrap .tab_cont').hide();
                    $(this).addClass('on');
                    $('.tab_wrap .tab_cont')
                        .eq(li_index)
                        .show();
                }
                return false;
            });
        },
        srchBtmClick(e) {
            if ($('.srchTop_wrap').hasClass('extend') == true) {
                $('.srchTop_wrap').removeClass('extend');
                $(e.target).attr('title', 'Expand');
            } else {
                $('.srchTop_wrap').addClass('extend');
                $(this).attr('title', 'Fold');
            }
        },
        contentClick(e, rowData, grid) {
            const colNm = e.columnName;
            // 20.08.07 - QUESTION_ID 복사를 위해서 클릭 막음
            if (colNm !== 'QUESTION_ID') {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Q&A List', '/skp/basis/myKnowledge/myQnA/myQuestion/questionDetail'),
                    query: { questionId: SDLUtil.nvl(rowData[e.rowKey]['QUESTION_ID']) },
                });
            }
        },
        menuCommit(menu, subMenu, conUrl) {
            for (const menus of this.menus) {
                for (const menu of menus.subMenu) {
                    let connUrl = menu.connUrl.replace('.skp', '');
                    if (
                        '/skp/basis/myKnowledge/myQnA/myQuestion/questionDetail' === conUrl &&
                        '/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionList' === connUrl
                    ) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return conUrl;
                    }
                }
            }

            return MenuUtil.getSupportMain();
        },
        async inquiryList(v, recursion) {
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: 'inquiryType' + v,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1CodeList = resp.data.result.rowData;
                        if (recursion) {
                            this.inquiry1Code = this.supportSnb.faqInquiry1Code;
                            this.inquiryList(2, true);
                        } else {
                            this.inquiry1Code = '';
                            this.inquiryList(2);
                        }
                    } else if (v === 2) {
                        this.inquiry2CodeList = resp.data.result.rowData;
                        if (recursion) {
                            this.inquiry2Code = this.supportSnb.faqInquiry2Code;
                        } else {
                            this.inquiry2Code = '';
                        }
                    }
                });
        },
        async categoryList(v, recursion) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    if (recursion) {
                        this.category1Code = this.supportSnb.faqCategory1Code;
                        this.categoryList(2, true);
                    } else if (!SDLUtil.isNull(resp[0])) {
                        this.category1Code = '';
                        this.categoryList(2);
                    }
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    if (recursion) {
                        this.category2Code = this.supportSnb.faqCategory2Code;
                        this.categoryList(3, true);
                    } else if (!SDLUtil.isNull(resp[0])) {
                        this.category2Code = '';
                        this.categoryList(3);
                    }
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category3CodeList = resp;
                    if (recursion) {
                        this.category3Code = this.supportSnb.faqCategory3Code;
                    } else if (!SDLUtil.isNull(resp[0])) {
                        this.category3Code = '';
                    }
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        getMobileColumn() {
            if (!this.isMobile()) {
                this.columns.push({
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.QUESTION.ID'),
                    name: 'QUESTION_ID',
                    align: 'center',
                    width: 110,
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                });
                this.columns.push({
                    header: SDLUtil.getMsgProp('FIELD.FAQ.INQUIRY'),
                    name: 'INQUIRY_TYPE_NM',
                    align: 'left',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                });
                this.columns.push({
                    header: SDLUtil.getMsgProp('FIELD.FAQ.CATEGORY'),
                    name: 'PRD_CATEGORY_NM',
                    align: 'left',
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                });
            }
            this.columns.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'),
                name: 'TITLE',
                align: 'left',
                resizable: true,
                sortable: false,
                className: 'cur_pointer',
            });
            if (!this.isMobile()) {
                this.columns.push({
                    header: SDLUtil.getMsgProp('FIELD.EXCEL.ANSWERED.BY'),
                    name: 'ANS_USER_NM',
                    align: 'center',
                    width: 90,
                    resizable: true,
                    sortable: false,
                    className: 'cur_pointer',
                });
            }
            this.columns.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'),
                name: 'REG_DT',
                align: 'center',
                width: 80,
                resizable: true,
                sortable: false,
                className: 'cur_pointer',
            });
            this.columns.push({
                header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'),
                name: 'COLOR_STATUS_NM',
                align: 'center',
                width: 110,
                resizable: true,
                sortable: false,
                className: 'cur_pointer',
            });
        },

        // 엑셀 다운로드 - 2020/08/06 김남갑 추가
        excelDownload() {
            SDLUtil.confirm({
                msg: 'MESSAGE.EXCEL.ALERT.MAXROWS',
                onOkEvt: () => {
                    let params = this.getSearchParams();
                    params.excelFile = 'MyQuestionList';
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionExcel.skp`,
                            qs.stringify(params),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
    beforeDestroy() {
        EventBus.$off('question-answer-list');
    },
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/qna/questionList.vue